import React from 'react';
import { Oval } from 'react-loader-spinner';

import { useAppSelector } from '../../../../app/hooks';
import { getWorkTimeForDriver } from '../../../../models';

import './PunchCardCard.scss';

export function PunchCardCard() {
  const punchCardsForDriver = useAppSelector(state => state.driversV2.punchCardsForDriver);
  const getPunchCardsAPI = useAppSelector(state => state.driversV2.getPunchCardsForDriver);

  const status = punchCardsForDriver?.summary.onClock ? 'On clock' : 'Not on clock';
  const workTime = getWorkTimeForDriver(punchCardsForDriver);

  return (
    <div className='punch-card-card'>
      <div className='punch-card-header'>
        <span className='punch-card-title'>Punch Card</span>
      </div>
      <div className='punch-card-divider' />

      {getPunchCardsAPI.loading ? (
        <div className='punch-card-loading'>
          <Oval color="#131313" height={20} width={20} secondaryColor="#FBD20A"/>
        </div>
      ) : (
        <div className='punch-card-content'>
          <div className='punch-card-row'>
            <span className='row-label'>Status</span>
            <span className={`row-value ${punchCardsForDriver?.summary.onClock ? 'on-clock' : ''}`}>
              {status}
            </span>
          </div>
          <div className='punch-card-row'>
            <span className='row-label'>Time worked</span>
            <span className='row-value'>{workTime}</span>
          </div>
        </div>
      )}
    </div>
  );
}
